import React, { useState } from 'react';
import {
  Select,
  SelectContent,
  SelectValue,
  SelectItem,
  SelectTrigger,
  Typography,
  cn,
  IconButton,
  FormField,
  FormLabel,
} from '@kiiwi/ui';
import FontAwesomeIcon from '@/components/atoms/FontawesomeIcon/FontawesomeIcon';
import useResponsive from '@/src/hooks/useResponsive';

type Props = {
  updateValue: (value: string) => void;
  resetValue: () => void;
  selectedValue?: string;
  options: { label: string; value: string; subLabel?: string }[];
  placeholder: string;
};
const TLCFilter = ({
  updateValue,
  resetValue,
  selectedValue,
  options,
  placeholder,
}: Props) => {
  const { isMobile } = useResponsive();
  const [isOpened, setIsOpened] = useState<boolean>(false);

  return (
    <>
      <FormField className="flex w-full sm:w-[178px]">
        {isMobile && <FormLabel className="text-left">{placeholder}</FormLabel>}
        <div className="flex w-full">
          <Select
            onValueChange={updateValue}
            value={selectedValue || ''}
            onOpenChange={setIsOpened}
          >
            <SelectTrigger
              size="md"
              className={cn(
                '!border-neutral transition-none',
                selectedValue
                  ? 'w-full rounded-br-none rounded-tr-none border-r-0 sm:w-[138px] sm:!border-brand-selected sm:bg-surface-light-brand'
                  : 'bg-surface-lighter sm:bg-surface-white',
                isOpened && '!border-brand-selected',
              )}
              icon={
                <div className="ml-1 h-4 w-4">
                  <FontAwesomeIcon
                    className="h-4 w-4"
                    name={`chevron-${isOpened ? 'up' : 'down'}:regular`}
                  />
                </div>
              }
            >
              <Typography
                variant="body-2"
                className={cn(
                  'text-ellipsis',
                  selectedValue && !isMobile && 'font-semibold',
                  !selectedValue && isMobile && 'text-neutral-secondary',
                )}
              >
                <SelectValue
                  aria-label={selectedValue}
                  placeholder={isMobile ? options[0].label : placeholder}
                >
                  {options.find(item => item.value === selectedValue)?.label ||
                    ''}
                </SelectValue>
              </Typography>
            </SelectTrigger>
            <SelectContent className="z-[1350]">
              {options.map(({ label, value, subLabel }) => (
                <SelectItem
                  key={value}
                  value={value}
                  className="hover:cursor-pointer"
                >
                  {label}
                  {subLabel && (
                    <Typography
                      variant="body-2"
                      className="text-neutral-secondary"
                    >
                      {subLabel}
                    </Typography>
                  )}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {!!selectedValue && (
            <div
              className={cn(
                'flex items-center justify-between rounded-br-lg rounded-tr-lg border-y border-r border-neutral bg-surface-lighter sm:border-brand-selected sm:bg-surface-light-brand',
                isOpened && 'border-brand-selected',
              )}
            >
              <div className="h-8 w-[1px] bg-surface-lighter py-1 sm:bg-surface-medium" />
              <IconButton
                className="h-[38px] w-[38px] sm:hover:bg-surface-light-brand"
                size="sm"
                onClick={resetValue}
              >
                <FontAwesomeIcon name="xmark:regular" />
              </IconButton>
            </div>
          )}
        </div>
      </FormField>
    </>
  );
};

export default TLCFilter;
